var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "user-list-grid",
      attrs: { id: "app-content" },
      on: {
        "&scroll": function($event) {
          return _vm.onScroll($event)
        }
      }
    },
    [
      _c(
        "form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showConfig.showNewUserForm,
              expression: "showConfig.showNewUserForm"
            }
          ],
          staticClass: "row",
          class: { sticky: _vm.scrolled && _vm.showConfig.showNewUserForm },
          attrs: { id: "new-user", disabled: _vm.loading.all },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.createUser($event)
            }
          }
        },
        [
          _c("div", {
            class: _vm.loading.all ? "icon-loading-small" : "icon-add"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "name" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newUser.id,
                  expression: "newUser.id"
                }
              ],
              ref: "newusername",
              attrs: {
                id: "newusername",
                disabled: _vm.settings.newUserGenerateUserID,
                placeholder: _vm.settings.newUserGenerateUserID
                  ? _vm.t("settings", "Will be autogenerated")
                  : _vm.t("settings", "Username"),
                autocapitalize: "none",
                autocomplete: "off",
                autocorrect: "off",
                name: "username",
                pattern: "[a-zA-Z0-9 _\\.@\\-']+",
                required: "",
                type: "text"
              },
              domProps: { value: _vm.newUser.id },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newUser, "id", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "displayName" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newUser.displayName,
                    expression: "newUser.displayName"
                  }
                ],
                attrs: {
                  id: "newdisplayname",
                  placeholder: _vm.t("settings", "Display name"),
                  autocapitalize: "none",
                  autocomplete: "off",
                  autocorrect: "off",
                  name: "displayname",
                  type: "text"
                },
                domProps: { value: _vm.newUser.displayName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.newUser, "displayName", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "password" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newUser.password,
                  expression: "newUser.password"
                }
              ],
              ref: "newuserpassword",
              attrs: {
                id: "newuserpassword",
                minlength: _vm.minPasswordLength,
                placeholder: _vm.t("settings", "Password"),
                required: _vm.newUser.mailAddress === "",
                autocapitalize: "none",
                autocomplete: "new-password",
                autocorrect: "off",
                name: "password",
                type: "password"
              },
              domProps: { value: _vm.newUser.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newUser, "password", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mailAddress" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newUser.mailAddress,
                  expression: "newUser.mailAddress"
                }
              ],
              attrs: {
                id: "newemail",
                placeholder: _vm.t("settings", "Email"),
                required:
                  _vm.newUser.password === "" ||
                  _vm.settings.newUserRequireEmail,
                autocapitalize: "none",
                autocomplete: "off",
                autocorrect: "off",
                name: "email",
                type: "email"
              },
              domProps: { value: _vm.newUser.mailAddress },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newUser, "mailAddress", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "groups" },
            [
              !_vm.settings.isAdmin
                ? _c("input", {
                    class: { "icon-loading-small": _vm.loading.groups },
                    attrs: {
                      id: "newgroups",
                      required: !_vm.settings.isAdmin,
                      tabindex: "-1",
                      type: "text"
                    },
                    domProps: { value: _vm.newUser.groups }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "Multiselect",
                {
                  staticClass: "multiselect-vue",
                  attrs: {
                    "close-on-select": false,
                    disabled: _vm.loading.groups || _vm.loading.all,
                    multiple: true,
                    options: _vm.canAddGroups,
                    placeholder: _vm.t("settings", "Add user in group"),
                    "tag-width": 60,
                    taggable: true,
                    label: "name",
                    "tag-placeholder": "create",
                    "track-by": "id"
                  },
                  on: { tag: _vm.createGroup },
                  model: {
                    value: _vm.newUser.groups,
                    callback: function($$v) {
                      _vm.$set(_vm.newUser, "groups", $$v)
                    },
                    expression: "newUser.groups"
                  }
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "noResult" }, slot: "noResult" },
                    [_vm._v(_vm._s(_vm.t("settings", "No results")))]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.subAdminsGroups.length > 0 && _vm.settings.isAdmin
            ? _c(
                "div",
                { staticClass: "subadmins" },
                [
                  _c(
                    "Multiselect",
                    {
                      staticClass: "multiselect-vue",
                      attrs: {
                        "close-on-select": false,
                        multiple: true,
                        options: _vm.subAdminsGroups,
                        placeholder: _vm.t("settings", "Set user as admin for"),
                        "tag-width": 60,
                        label: "name",
                        "track-by": "id"
                      },
                      model: {
                        value: _vm.newUser.subAdminsGroups,
                        callback: function($$v) {
                          _vm.$set(_vm.newUser, "subAdminsGroups", $$v)
                        },
                        expression: "newUser.subAdminsGroups"
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "noResult" }, slot: "noResult" },
                        [_vm._v(_vm._s(_vm.t("settings", "No results")))]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "quota" },
            [
              _c("Multiselect", {
                staticClass: "multiselect-vue",
                attrs: {
                  "allow-empty": false,
                  options: _vm.quotaOptions,
                  placeholder: _vm.t("settings", "Select user quota"),
                  taggable: true,
                  label: "label",
                  "track-by": "id"
                },
                on: { tag: _vm.validateQuota },
                model: {
                  value: _vm.newUser.quota,
                  callback: function($$v) {
                    _vm.$set(_vm.newUser, "quota", $$v)
                  },
                  expression: "newUser.quota"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showConfig.showLanguages
            ? _c(
                "div",
                { staticClass: "languages" },
                [
                  _c("Multiselect", {
                    staticClass: "multiselect-vue",
                    attrs: {
                      "allow-empty": false,
                      options: _vm.languages,
                      placeholder: _vm.t("settings", "Default language"),
                      "group-label": "label",
                      "group-values": "languages",
                      label: "name",
                      "track-by": "code"
                    },
                    model: {
                      value: _vm.newUser.language,
                      callback: function($$v) {
                        _vm.$set(_vm.newUser, "language", $$v)
                      },
                      expression: "newUser.language"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showConfig.showStoragePath
            ? _c("div", { staticClass: "storageLocation" })
            : _vm._e(),
          _vm._v(" "),
          _vm.showConfig.showUserBackend
            ? _c("div", { staticClass: "userBackend" })
            : _vm._e(),
          _vm._v(" "),
          _vm.showConfig.showLastLogin
            ? _c("div", { staticClass: "lastLogin" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "userActions" }, [
            _c("input", {
              staticClass: "button primary icon-checkmark-white has-tooltip",
              attrs: {
                id: "newsubmit",
                title: _vm.t("settings", "Add a new user"),
                type: "submit",
                value: ""
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "closeButton" },
              [
                _c(
                  "Actions",
                  [
                    _c(
                      "ActionButton",
                      {
                        attrs: { icon: "icon-close" },
                        on: { click: _vm.onClose }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.t("settings", "Close")) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row",
          class: { sticky: _vm.scrolled && !_vm.showConfig.showNewUserForm },
          attrs: { id: "grid-header" }
        },
        [
          _c("div", { staticClass: "avatar", attrs: { id: "headerAvatar" } }),
          _vm._v(" "),
          _c("div", { staticClass: "name", attrs: { id: "headerName" } }, [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.t("settings", "Username")) + "\n\n\t\t\t"
            ),
            _c("div", { staticClass: "subtitle" }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.t("settings", "Display name")) +
                  "\n\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "password", attrs: { id: "headerPassword" } },
            [
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.t("settings", "Password")) + "\n\t\t"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mailAddress", attrs: { id: "headerAddress" } },
            [_vm._v("\n\t\t\t" + _vm._s(_vm.t("settings", "Email")) + "\n\t\t")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "groups", attrs: { id: "headerGroups" } }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.t("settings", "Groups")) + "\n\t\t")
          ]),
          _vm._v(" "),
          _vm.subAdminsGroups.length > 0 && _vm.settings.isAdmin
            ? _c(
                "div",
                { staticClass: "subadmins", attrs: { id: "headerSubAdmins" } },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.t("settings", "Group admin for")) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "quota", attrs: { id: "headerQuota" } }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.t("settings", "Quota")) + "\n\t\t")
          ]),
          _vm._v(" "),
          _vm.showConfig.showLanguages
            ? _c(
                "div",
                { staticClass: "languages", attrs: { id: "headerLanguages" } },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.t("settings", "Language")) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showConfig.showUserBackend || _vm.showConfig.showStoragePath
            ? _c("div", { staticClass: "headerUserBackend userBackend" }, [
                _vm.showConfig.showUserBackend
                  ? _c("div", { staticClass: "userBackend" }, [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.t("settings", "User backend")) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showConfig.showStoragePath
                  ? _c("div", { staticClass: "subtitle storageLocation" }, [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.t("settings", "Storage location")) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showConfig.showLastLogin
            ? _c("div", { staticClass: "headerLastLogin lastLogin" }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.t("settings", "Last login")) +
                    "\n\t\t"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "userActions" })
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.filteredUsers, function(user, key) {
        return _c("user-row", {
          key: key,
          attrs: {
            "external-actions": _vm.externalActions,
            groups: _vm.groups,
            languages: _vm.languages,
            "quota-options": _vm.quotaOptions,
            settings: _vm.settings,
            "show-config": _vm.showConfig,
            "sub-admins-groups": _vm.subAdminsGroups,
            user: user
          }
        })
      }),
      _vm._v(" "),
      _c(
        "InfiniteLoading",
        { ref: "infiniteLoading", on: { infinite: _vm.infiniteHandler } },
        [
          _c("div", { attrs: { slot: "spinner" }, slot: "spinner" }, [
            _c("div", { staticClass: "users-icon-loading icon-loading" })
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }, [
            _c("div", { staticClass: "users-list-end" })
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }, [
            _c("div", { attrs: { id: "emptycontent" } }, [
              _c("div", { staticClass: "icon-contacts-dark" }),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm.t("settings", "No users in here")))])
            ])
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }